import { setQueryString, getQueryString } from '@/utils/UrlUtils';

const INITIAL_STATE = {
  numberOfCards: '',
  postalAddress: '',
  recentOrder: {},
  currentPage: 1,
};

export default {
  namespaced: true,

  state: { ...INITIAL_STATE },

  mutations: {
    resetState(state) {
      Object.assign(state, INITIAL_STATE);
    },

    updateNumberOfCards(state, data) {
      state.numberOfCards = data;
    },

    updatePostalAddress(state, data) {
      state.postalAddress = data;
    },

    updateRecentOrder(state, data) {
      state.recentOrder = data;
    },

    updateCurrentPage(state, data) {
      state.currentPage = data;

      if (Number(getQueryString('step')) !== Number(data)) {
        setQueryString('step', data);
      }
    },
  },

  getters: {
    getNumberOfCards: (state) => {
      return state.numberOfCards;
    },

    getPostalAddress: (state) => {
      return state.postalAddress;
    },

    getRecentOrder: (state) => {
      return state.recentOrder;
    },

    getCurrentPage: (state) => {
      return state.currentPage;
    },
  },
};
